import {PluginsContext} from '@packages/systems/wfdl';
import {LocaleItemContext} from '@packages/shared/constants/Render';

export default function getActiveLocale(
  pluginsContext: PluginsContext
): LocaleItemContext | null {
  const locales = pluginsContext.getIn(['Localization', 'locales']);

  if (!locales) {
    return null;
  }

  return locales.find((locale: LocaleItemContext) => locale.active);
}
